var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4348 17C11.9288 17 11.4448 16.767 11.1088 16.358L6.89584 11.26C6.39184 10.649 6.29084 9.782 6.63684 9.049C6.94184 8.402 7.54884 8 8.22184 8H16.6478C17.3208 8 17.9278 8.402 18.2328 9.049C18.5788 9.782 18.4778 10.649 17.9748 11.259L13.7608 16.358C13.4248 16.767 12.9408 17 12.4348 17Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_4137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 13,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4348 17C11.9288 17 11.4448 16.767 11.1088 16.358L6.89584 11.26C6.39184 10.649 6.29084 9.782 6.63684 9.049C6.94184 8.402 7.54884 8 8.22184 8H16.6478C17.3208 8 17.9278 8.402 18.2328 9.049C18.5788 9.782 18.4778 10.649 17.9748 11.259L13.7608 16.358C13.4248 16.767 12.9408 17 12.4348 17Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_4137)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevron);
export default __webpack_public_path__ + "static/media/iconChevron.90c9737c0c580cef95fc14c6dc5e54da.svg";
export { ForwardRef as ReactComponent };